import React from 'react';
import PropTypes from 'prop-types';
import useUnsavedChangesSimple from '../../hooks/useUnsavedChangesSimple';
import UnsavedChangesModal from './UnsavedChangesModal';

/**
 * Component that wraps forms with unsaved changes protection
 * Combines the hook and modal into a single easy-to-use component
 */
const UnsavedChangesGuard = ({
  hasUnsavedChanges,
  children,
  title,
  message,
  warningText,
  discardButtonText,
  keepEditingButtonText,
  enableBrowserWarning = true,
  onBeforeLeave = null,
}) => {
  const { showModal, handleKeepEditing, handleDiscardChanges } = useUnsavedChangesSimple(
    hasUnsavedChanges,
    {
      enableBrowserWarning,
    }
  );

  return (
    <>
      {children}
      <UnsavedChangesModal
        open={showModal}
        onDiscard={handleDiscardChanges}
        onKeepEditing={handleKeepEditing}
        title={title}
        message={message}
        warningText={warningText}
        discardButtonText={discardButtonText}
        keepEditingButtonText={keepEditingButtonText}
      />
    </>
  );
};

UnsavedChangesGuard.propTypes = {
  hasUnsavedChanges: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  warningText: PropTypes.string,
  discardButtonText: PropTypes.string,
  keepEditingButtonText: PropTypes.string,
  enableBrowserWarning: PropTypes.bool,
  onBeforeLeave: PropTypes.func,
};

export default UnsavedChangesGuard;
